import { groupBy, map, keys, uniq, sortWith, ascend, prop } from 'ramda'

import { genLabel, labelHeader } from './label'

export const groupData = ({ rows, group }) => {
  const byOrder = groupBy(row => row.OrderID)
  const orders = byOrder(rows)
  const groupItems = (pack) => {
    const items = []
    if (pack.Item1 && !isNaN(parseInt(pack.Quantity1, 10))) {
      items.push({ name: pack.Item1, amount: parseInt(pack.Quantity1, 10) })
    }
    if (pack.Item2 && !isNaN(parseInt(pack.Quantity2, 10))) {
      items.push({ name: pack.Item2, amount: parseInt(pack.Quantity2, 10) })
    }
    if (pack.Item3 && !isNaN(parseInt(pack.Quantity3, 10))) {
      items.push({ name: pack.Item3, amount: parseInt(pack.Quantity3, 10) })
    }
    const groupedItems = groupBy(item => item.name, items)
    const countedItems = map(g => g.reduce((prev, item) => prev + item.amount, 0), groupedItems)
    return keys(countedItems).map(name => ({ name, amount: countedItems[name] }))
  }
  const sortItems = items => sortWith([ascend(prop('name'))])(items)
  const data = []
  Object.keys(orders).map(orderId => orders[orderId]).forEach((order) => {
    order.forEach((pack, index) => {
      const mappedItems = groupItems(pack)
      data.push({
        app: 'inbox',
        referenceId: pack.OrderID,
        recipient: pack['First Name (Shipping)'].replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
        address: pack['Address 1 (Shipping)'].replace(/\s{1,}/g, ' ').replace(/\u200B/g, ''),
        data: {
          count: pack.Quantity,
          items: sortItems(mappedItems),
          phones: [pack.Tel],
        },
        seq: index + 1,
        last: order.length,
        group,
        remarks: '',
      })
    })
  })
  return data
}
export const createLabel = (label, labelQrcode) => `
<td class="main-cell">
  <div class="label">
    ${labelHeader}
    <div class="recipient">
      [${label.referenceId}] ${label.recipient} (${uniq(label.data.phones).join(', ')})<br />
      ${label.address}
    </div>
    <div class="items">
      ${label.data.items.map(d => `[ ${d.amount} ] ${d.name}`).join('<br />')}
    </div>
    ${labelQrcode(label)}
  </div>
</td>`

export default {
  groupData,
  genLabel: genLabel(createLabel),
}



// WEBPACK FOOTER //
// ./src/helpers/inbox.js